export default {
  name: "home",
  watch: {
    $route: function () {
      this.$nextTick(() => {
        let top = 0;
        // @ts-ignore
        if (this.$route.query.type == "history") {
          top = this.$refs.history.offsetTop;
        }
        window.scrollTo(0, top);
      });
    }
  }
};